
import React from 'react';
import { useAuth } from '@/contexts/auth/useAuth';
import AccountButton from '@/components/auth/AccountButton';
import UserProfileMenu from '@/components/auth/UserProfileMenu';
import AuthTabs from '@/components/auth/AuthTabs';

const AuthLinks = () => {
  const { isAuthenticated } = useAuth();

  return (
    <div className="relative z-[100]">
      <AccountButton>
        {isAuthenticated ? <UserProfileMenu /> : <AuthTabs />}
      </AccountButton>
    </div>
  );
};

export default AuthLinks;
